module.exports = __webpack_public_path__ + "static/media/parts_09.c42c81cd.svg";